import { hot } from 'react-hot-loader'

const WrapperComponent = ({ children }) => children

export const Wrapper = hot(module)(WrapperComponent)
